export default class ScreeningSurvey {
    constructor() {

		$(".question_9 input").click(function() {

            if($(this).val() == 'no') {
                $(".question_6").fadeIn();
            }else{
                $(".question_6").fadeOut();
                $(".question_6 input").prop('checked', false);
            }

        });

    }
}
 